import {
  consumeShareLinkRedirect,
  POST_ONBOARDING_REDIRECT_KEY,
} from "../../utils/shareLinkRedirect";

export { POST_ONBOARDING_REDIRECT_KEY };

/**
 * Shared post-onboarding-completion navigator.
 *
 * Both the whats-next route (`Review Portfolio` mutation onSuccess) and
 * the CompleteOnboardingDialog (form submit) need the exact same
 * branching:
 *  1. If a share-link redirect is stashed, navigate there and fire the
 *     `share_link_signup_completed` PostHog event.
 *  2. Otherwise, navigate to the supplied default route.
 *
 * Centralizing this means a future change to the analytics event name
 * or the safety check can't drift between the two surfaces.
 */
export function navigateAfterOnboarding(deps: {
  navigate: (args: { to: string }) => void;
  posthog: {
    capture: (event: string, props: Record<string, unknown>) => void;
  };
  defaultRoute: string;
}): void {
  const redirectTo = consumeShareLinkRedirect();
  if (redirectTo) {
    deps.posthog.capture("share_link_signup_completed", { redirectTo });
    deps.navigate({ to: redirectTo });
    return;
  }
  deps.navigate({ to: deps.defaultRoute });
}
